/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-02-06",
    versionChannel: "nightly",
    buildDate: "2025-02-06T00:06:02.281Z",
    commitHash: "40437b0bb3943f8dde42e2f207b91b928d2d6905",
};
